import { IconProps } from './interfaces';

export const IconXTwitter = ({ className }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
            <path d="M17.8014 4H20.867L14.136 11.214L22 21H15.8287L10.997 15.0531L5.46551 21H2.39987L9.53082 13.2841L2 4H8.32456L12.6898 9.43247L17.8014 4ZM16.7284 19.3063H18.4279L7.43152 5.631H5.60546L16.7284 19.3063Z" />
        </svg>
    );
};
